import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { IconButton } from 'native-base';
import React from 'react';

interface MovementItemHeaderProps {
  fundName: string;
  fundCnpj: string;
  handleChangeIsOpened: () => void;
  isOpened: boolean;
}

export const MovementItemHeader: React.FC<MovementItemHeaderProps> = ({
  fundCnpj,
  fundName,
  handleChangeIsOpened,
  isOpened,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  if (isMobile) {
    return (
      <VStack py={Spacing['inline.xxxs']} space={Spacing['inset.quarck']}>
        <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.black'}>
          Fundo
        </Text>
        <HStack alignItems={'center'} justifyContent="space-between" space={Spacing['inline.xxxs']}>
          <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
            {fundName}
          </Text>
          <IconButton
            p={0}
            onPress={handleChangeIsOpened}
            variant="unstyled"
            icon={
              <Icon
                testID="accordion-chevron-icon"
                name={isOpened ? 'ChevronUp' : 'ChevronDown'}
                size={'xs'}
                color={Color['neutral.dark']}
              />
            }
          />
        </HStack>
        <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
          CNPJ: {fundCnpj}
        </Text>
      </VStack>
    );
  }

  if (isTablet) {
    return (
      <HStack py={Spacing['inline.xxxs']} justifyContent={'space-between'}>
        <VStack space={Spacing['inset.quarck']}>
          <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.black'}>
            Fundo
          </Text>
          <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
            {fundName}
          </Text>
        </VStack>
        <HStack space={Spacing['inset.xs']} alignItems={'center'}>
          <VStack space={Spacing['inset.quarck']} alignItems={'flex-end'}>
            <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.black'}>
              CNPJ
            </Text>
            <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
              {fundCnpj}
            </Text>
          </VStack>
          <IconButton
            p={0}
            onPress={handleChangeIsOpened}
            variant="unstyled"
            icon={
              <Icon
                testID="accordion-chevron-icon"
                name={isOpened ? 'ChevronUp' : 'ChevronDown'}
                size={'xs'}
                color={Color['neutral.dark']}
              />
            }
          />
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" py={Spacing['inline.xxxs']}>
      <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.dark'}>
        {fundName}
      </Text>
      <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
        <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.dark'}>
          CNPJ: {fundCnpj}
        </Text>
        <IconButton
          p={0}
          onPress={handleChangeIsOpened}
          variant="unstyled"
          icon={
            <Icon
              testID="accordion-chevron-icon"
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size={'xs'}
              color={Color['neutral.dark']}
            />
          }
        />
      </HStack>
    </HStack>
  );
};
